import styled, { css } from 'styled-components';
import { Uppercase } from './PlayUppercase.styles';
import { playFontSize } from './helpers';
import { device } from '../breakpoints';

const getMqMedium = (type?: string) => {
    if (type && type === 'large') {
        return `
            @media ${device.GteMedium} {
                ${playFontSize(1.5)}
            }
        `;
    }

    return '';
};

export const PlayPrefixTypography = css`
    ${Uppercase}
    ${playFontSize(1.3)}

    @media ${device.GteLarge} {
        ${playFontSize(1.4)}
    }
`;

export const PlayPrefix = styled.p<{ type?: string }>`
    ${PlayPrefixTypography}
    ${(props) => getMqMedium(props.type)}
`;
